import request from "@/request";
import { Article, Detail, InfoDetailModel, InfoListModel, Page, SpecialListModel, TagList } from "@/api/college/model";

export class College {
  //专题
  static SpecialList() {
    return request.get<SpecialListModel[]>('/app-api/wb/topics')
  }

  //热门标签
  static HotTags() {
    return request.get<TagList[]>('/app-api/wb/tags')
  }

  //最新资讯
  static NewestInfo(params: Page) {
    return request.get<InfoListModel[]>('/app-api/wb/news/page', params)
  }

  //最新资讯（标签、专题）
  static NewestInfoEntry(params: Page) {
    return request.get<InfoListModel[]>('/app-api/wb/news/page', params)
  }
  //资讯详情
  static InfoDetail(data: InfoDetailModel) {
    return request.get<Detail>('/app-api/wb/news/detail', data)
  }

  //推荐资讯
  static recommend(params: Page) {
    return request.get<Article[]>('/app-api/wb/news/page', params)
  }
}
